define('modules/editor/behaviours/hoverable',['require','exports','module','backbone','./lib/hover_layers','underscore'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      hoverLayers = require("./lib/hover_layers"),
      _ = require("underscore");

  var hoverableEvents = {
    "mouseover": "_onMouseEnter",
    "mouseleave": "_onMouseLeave",
    "dragover": "_onDragEnter",
    "dragleave": "_onDragLeave",
    "drop": "_onDrop",
    "dragend": "_onDrop"
  };

  module.exports = {
    _onMouseEnter: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$el.removeClass("drag-in-hover");
      this.$el.addClass("item-hover");
    },

    _onMouseLeave: function() {
      this.$el.removeClass("item-hover");
    },

    _allowedContainers: ["section", "area"],

    _onDragEnter: function(e) {
      var payload = this.data.state.getDragPayload(),
          dataTransfer = e.originalEvent.dataTransfer,
          isContainer = _.contains(this._allowedContainers, this.model.name);
      //show only when dragging a new element from the sidebar
      //or if the section is different than the original element's section
      if(dataTransfer.effectAllowed === "move" && (isContainer && this.model.contains(payload.model))){
        //moving element within the same section, do nothing
        return;
      }
      var sectionView;
      if (this.$el.hasClass("ed-item-section") || this.$el.hasClass("ed-item-area")) {
        sectionView = this;
      } else {
        sectionView = this.parent;
      }
      clearTimeout(sectionView._timeout);
      if (!sectionView.$el.hasClass("drag-in-hover")) {
        sectionView.$el.addClass("drag-in-hover");
        hoverLayers.DragOver.injectIn(sectionView.el);
      }
    },

    _onDragLeave: function() {
      var $el = this.$el,
          el = this.el;
      // timeout = to smooth the dragover/dragleave rapid fire
      this._timeout = setTimeout(function() {
        $el.removeClass("drag-in-hover");
        hoverLayers.DragOver.removeFrom(el);
      }, 100);
    },

    _onDrop: function() {
      this.$el.removeClass("drag-in-hover");
      hoverLayers.DragOver.removeFrom(this.el);
    },

    _hoverableRender: function(init) {
      return init.call(this);
    },

    mixed: function(klass, proto) {
      // some keys in "events" can override some proto.events, so it's important
      // to create a wrapper function to call both the klass' and the mixins'
      var overridenEvents = {};
      // jshint ignore:start
      for (var key in proto.events) {
        if (proto.events.hasOwnProperty(key)
            && hoverableEvents.hasOwnProperty(key)) {
          overridenEvents[key] = _.wrap(proto[proto.events[key]], (function(key) {
            return function(orig) {
              this[hoverableEvents[key]].apply(this, _.rest(arguments));
              return orig.apply(this, _.rest(arguments));
            };
          }(key)));
        }
      }
      // jshint ignore:end
      proto.events = _.extend(proto.events || {}, hoverableEvents, overridenEvents);
      proto.render = _.wrap(proto.render, this._hoverableRender);
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this._hoverableData = new Backbone.Model();
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

